/**
 * Admin Backups Page - Shows all backups across the platform
 */
import React from "react";
import Backups from "../Backups";

const AdminBackups = () => {
  return <Backups />;
};

export default AdminBackups;
